import { countryList } from 'util/icwUtility';
import T from 'i18n-react';

const countryListOptions = countryList.map(({ region }) => ({
  label: region,
  value: region,
}));

export default {
  SERVICE_LEVEL: [
    {
      value: 'regular',
      label: 'Regular',
    },
    {
      value: 'express',
      label: 'Express',
    },
    {
      value: 'shuttleEmergency',
      label: 'Shuttle / Emergency',
    },
  ],
  COUNTRY_LIST: countryListOptions,
  INTENDED_USAGE: [
    {
      value: 'general',
      label: 'General product',
    },
    {
      value: 'adult',
      label: 'Adult product',
    },
    {
      value: 'children',
      label: 'Children product',
    },
    {
      value: 'toys',
      label: 'Toys',
    },
  ],
  RATING: [
    {
      label: T.translate('supplierManager.ratings.any'),
      value: '',
    },
    {
      label: T.translate('supplierManager.ratings.fourHalfAndUp'),
      value: '4.5',
    },
    {
      label: T.translate('supplierManager.ratings.fourAndUp'),
      value: '4',
    },
    {
      label: T.translate('supplierManager.ratings.threeHalfAndUp'),
      value: '3.5',
    },
    {
      label: T.translate('supplierManager.ratings.threeAndUp'),
      value: '3',
    },
    {
      label: T.translate('supplierManager.ratings.twoHalfAndUp'),
      value: '2.5',
    },
    {
      label: T.translate('supplierManager.ratings.twoAndUp'),
      value: '2',
    },
  ],
};
